// extracted by mini-css-extract-plugin
module.exports = {"textDanger":"Lazada_textDanger__mx2m_","textBold":"Lazada_textBold__g9dAW","textSuccess":"Lazada_textSuccess__tuosg"};